<template>
    <div class="block__wrap">
        <!--1-->
        <button class="block-toggle-ttl opener" type="button" data-toggle="collapse" data-target="#heading-1" aria-expanded="true" aria-controls="category">
            <strong class="title-required"> General Business Information</strong>
            <div class="plus-minus"></div>
        </button>
        <div class="block-toggle-content collapse show" id="heading-1" aria-labelledby="block-toggle-ttl">
            <ValidationObserver ref="businessInformationForm">
                <div class="row mb-0">
                    <ValidationProvider class="col-sm-12 col-md-6" name="Title" rules="required" v-slot="{ errors }">
                        <div class="form-group mb-0">
                            <label class="lbl lbl-required">Title</label>
                            <input type="text" class="form-control mb-1" placeholder="i.e. Vice President, Associate..." aria-label="title" v-model="businessInformationForm.title">
                        </div>

                        <div class="form-group field-validation-error">
                            {{ errors[0] }}
                        </div>
                    </ValidationProvider>
                    <ValidationProvider
                        class="col-sm-12 col-md-6"
                        name="Company Name"
                        :rules="{
                            required: true,
                            min:3,
                            max:40,
                            regex: /^[0-9,a-z,A-Z,\s,',\-,&.]+$/
                        }"
                        v-slot="{ errors }"
                    >
                        <div class="form-group mb-0">
                            <label class="lbl lbl-required">Company Name</label>
                            <input type="text" class="form-control mb-1" placeholder="i.e. Google" aria-label="company name" v-model="businessInformationForm.company_name">
                        </div>

                        <div class="form-group field-validation-error">
                            {{ errors[0] }}
                        </div>
                    </ValidationProvider>
                </div>
                <div class="row mb-0 form-group align-items-center">
                    <label class="col-lg-12 lbl lbl-required">Full Name</label>
                    <div class="col-12">
                        <div class="row justify-content-between dashed-bb">
                            <ValidationProvider class="col-lg-6" name="First Name" rules="required|alpha_spaces|min:2|max:20" v-slot="{ errors }">
                                <div class="form-group mb-0">
                                    <input type="text" placeholder="First Name" class="form-control mb-1" v-model="businessInformationForm.first_name">
                                </div>

                                <div class="form-group field-validation-error">
                                    {{ errors[0] }}
                                </div>
                            </ValidationProvider>
                            <ValidationProvider class="col-lg-6" name="Last Name" rules="required|alpha_spaces|min:2|max:20" v-slot="{ errors }">
                                <div class="form-group mb-0">
                                    <input type="text" placeholder="Last Name" class="form-control mb-1" v-model="businessInformationForm.last_name">
                                </div>

                                <div class="form-group field-validation-error">
                                    {{ errors[0] }}
                                </div>
                            </ValidationProvider>
                        </div>
                    </div>
                </div>
                <div class="row mb-0">
                    <ValidationProvider class="col-sm-12 col-md-6" name="Email Address" rules="required|email" v-slot="{ errors }">
                        <div class="form-group mb-0">
                            <label class="lbl lbl-required">Email Address</label>
                            <input type="email" placeholder="i.e. test@domain.com" class="form-control mb-1" aria-label="email" v-model="businessInformationForm.email">
                        </div>

                        <div class="form-group field-validation-error">
                            {{ errors[0] }}
                        </div>
                    </ValidationProvider>
                    <ValidationProvider
                        class="col-sm-12 col-md-6"
                        name="Cellphone"
                        rules="required|us_phone_number"
                        v-slot="{ errors }"
                    >
                        <div class="form-group mb-0">
                            <label class="lbl lbl-required">Cellphone</label>
                            <input
                                type="text"
                                class="form-control mb-1"
                                aria-label="phone number"
                                placeholder="i.e. (123) 456-7890"
                                v-mask="'+1(###)-###-####'"
                                v-model="businessInformationForm.cellphone"
                            />
                        </div>

                        <div class="form-group field-validation-error">
                            {{ errors[0] }}
                        </div>
                    </ValidationProvider>
                </div>
                <div class="row mb-0">
                    <ValidationProvider
                        class="col-sm-12 col-md-6"
                        name="Establishment"
                        :rules="{
                            required: true,
                            numeric: true,
                            min_value: 1936,
                            max_value: (new Date()).getFullYear()
                        }"
                        v-slot="{ errors }"
                    >
                        <div class="form-group mb-0">
                            <label class="lbl lbl-required">Year your company was established</label>
                            <select class="form-control mb-1" placeholder='i.e. 1974' aria-label="established date" v-model="businessInformationForm.company_established_year">
                                <option :value="null" disabled>Select a year</option>
                                <option v-for="(year, index) in yearsList" :key="index" :value="`${year}`">{{ year }}</option>
                            </select>
                        </div>

                        <div class="form-group field-validation-error">
                            {{ errors[0] }}
                        </div>
                    </ValidationProvider>
                    <ValidationProvider class="col-sm-12 col-md-6" name="Generation" rules="required" v-slot="{ errors }">
                        <div class="form-group mb-0">
                            <label class="lbl lbl-required">Generation</label>
                            <input type="text" placeholder="i.e. 2nd, 3rd, 4th" class="form-control mb-1" aria-label="generation" v-model="businessInformationForm.generation">
                        </div>

                        <div class="form-group field-validation-error">
                            {{ errors[0] }}
                        </div>
                    </ValidationProvider>
                </div>
            </ValidationObserver>
        </div>
        <!--2-->
        <button class="block-toggle-ttl opener collapsed" type="button" data-toggle="collapse" data-target="#heading-2" aria-expanded="false" aria-controls="category">
            <strong class="title-required">My Bio</strong>
            <div class="plus-minus"></div>
        </button>
        <div class="block-toggle-content collapse" id="heading-2" aria-labelledby="block-toggle-ttl" >
            <p>Please make sure it says this is the description of your company that will be displayed on the website</p>
            <ValidationObserver ref="bioInformationForm">
                <div class="row mb-0">
                    <ValidationProvider class="col-sm-12 col-md-12 col-xl-12" name="Bio" rules="required|min:10|max:200" v-slot="{ errors }">
                        <div class="form-group mb-0">
                            <textarea rows="3" class="form-control mb-1" placeholder='Type description here...' aria-label="bio description add here" v-model="bioInformationForm.bio"></textarea>
                        </div>

                        <div class="form-group field-validation-error">
                            {{ errors[0] }}
                        </div>
                    </ValidationProvider>
                </div>
            </ValidationObserver>
        </div>
        <!--3-->
        <button class="block-toggle-ttl opener collapsed mb-0" type="button" data-toggle="collapse" data-target="#heading-3" aria-expanded="false" aria-controls="category">
            <strong class="title-required">Family Members in your business</strong>
            <div class="plus-minus"></div>
        </button>
        <div class="block-toggle-content collapse" id="heading-3" aria-labelledby="block-toggle-ttl">
            <ValidationObserver ref="familyMembersForm">
                <ValidationProvider name="Family Members" rules="required" v-slot="{ errors }">
                    <div class="row">
                        <div class="col-sm-12 col-md-6 mb-0" v-for="(member, index) in familyMembersList">
                            <div class="form-group row align-items-center mb-0">
                                <div class="col-sm-12">
                                    <div class="form-check" @click="familyMembersForm.comment = null">
                                        <input class="form-check-input-checkbox" type="checkbox" :id="`member-${member}-${index}`" :value="member" v-model="familyMembersForm.family_members">
                                        <label class="form-check-label" :for="`member-${member}-${index}`">{{ member.ucfirst() }}</label>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <ValidationProvider
                            class="col-sm-12 col-md-6 mb-0"
                            v-if="familyMembersForm.family_members.includes('other')"
                            name="Family Members"
                            :rules="{ required_if: familyMembersForm.family_members.includes('other') }"
                            v-slot="{ errors }"
                        >
                            <div v-show="familyMembersForm.family_members.includes('other')">
                                <div class="form-group row align-items-center mb-0">
                                    <div class="col-sm-12">
                                        <input type="text" class="form-control mb-0" placeholder='Your comment here...' aria-label="other family member in business put here" v-model="familyMembersForm.comment">
                                    </div>
                                </div>
                            </div>

                            <div class="form-group field-validation-error">
                                {{ errors[0] }}
                            </div>
                        </ValidationProvider>
                    </div>

                    <div class="form-group field-validation-error">
                        {{ errors[0] }}
                    </div>
                </ValidationProvider>

                <ValidationProvider name="Family Business Years" rules="required|numeric|min_value:1|max_value:200" v-slot="{ errors }">
                    <div class="row form-group align-items-center mb-0">
                        <label class="col-md-8 col-lg-8 lbl lbl-big-required">How many years have you been in the family business?</label>
                        <div class="col-md-4 col-lg-4">
                            <input type="search" class="form-control" autocomplete="off" v-mask="'###'" v-model="familyMembersForm.years_in_business">
                        </div>
                    </div>

                    <div class="form-group field-validation-error">
                        {{ errors[0] }}
                    </div>
                </ValidationProvider>
            </ValidationObserver>
        </div>
        <!--4-->
        <button class="block-toggle-ttl wt-pad opener collapsed" type="button" data-toggle="collapse" data-target="#heading-4" aria-expanded="false" aria-controls="category">
            <strong>
                <p class="title-required">Do you plan on succeeding your family member and running the family business?</p>
                <small class="lbl lbl-required">Are you going to stick around?</small>
            </strong>
            <div class="plus-minus"></div>
        </button>
        <div class="block-toggle-content collapse" id="heading-4" aria-labelledby="block-toggle-ttl" >
            <ValidationObserver ref="familyBusinessForm">
                <ValidationProvider class="choose-block-wrap succeed-choose mb-5" name="Family Business" rules="required" v-slot="{ errors }">
                    <div class="item">
                        <input type="radio" name="succeed" class="rad" id="succeed-yes" value="yes" v-model="familyBusinessForm.plan_be_family_members">
                        <label for="succeed-yes">
                            <span :class="{'ttl': !input_company_details}">YES</span>
                        </label>
                    </div>
                    <div class="item">
                        <input type="radio" name="succeed" class="rad" id="succeed-no" value="no" v-model="familyBusinessForm.plan_be_family_members">
                        <label for="succeed-no">
                            <span>NO</span>
                        </label>
                    </div>
                    <div class="item">
                        <input type="radio" name="succeed" class="rad" id="succeed-unsure" value="unsure" v-model="familyBusinessForm.plan_be_family_members">
                        <label for="succeed-unsure">
                            <span :class="{'ttl': !input_company_details}">UNSURE</span>
                        </label>
                    </div>

                    <div class="form-group field-validation-error">
                        {{ errors[0] }}
                    </div>
                </ValidationProvider>
                <ValidationProvider name="Education Level" rules="required" v-slot="{ errors }">
                    <div class="form-group row" >
                        <label class="col-lg-12 mb-4 lbl lbl-big lbl-required">What is your highest level of education?</label>
                        <div class="col-sm-12 col-md-6 mb-0" v-for="(education, index) in educationLevelList">
                            <div class="form-group row align-items-center mb-0">
                                <div class="col-12">
                                    <div class="form-check mb-3">
                                        <input
                                            class="form-check-input form-check-input-radio"
                                            name="education-level"
                                            type="radio"
                                            :id="`education-${education.value}-${index}`"
                                            :value="education.value"
                                            v-model="familyBusinessForm.education_level"
                                        >
                                        <label class="form-check-label" :for="`education-${education.value}-${index}`">{{ education.name }}</label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="form-group field-validation-error">
                        {{ errors[0] }}
                    </div>
                </ValidationProvider>
            </ValidationObserver>
        </div>
        <!--5-->
        <button class="block-toggle-ttl opener collapsed" type="button" data-toggle="collapse" data-target="#heading-5" aria-expanded="false" aria-controls="category">
            <strong class="title-required">How many employees are in the company?</strong>
            <div class="plus-minus"></div>
        </button>
        <div class="block-toggle-content collapse" id="heading-5" aria-labelledby="block-toggle-ttl" >
            <ValidationObserver ref="employeeInfoForm">
                <ValidationProvider name="Employee Amount" rules="required" v-slot="{ errors }">
                    <div :class="['choose-block-wrap', input_company_details && input_user_details ? 'employee-wrap-inner': 'employee-wrap']">
                        <div class="item" v-for="(employee, index) in employeesAmountList">
                            <input type="radio" name="employee-number" class="rad" :id="`employee-${employee}-${index}`" :value="employee" v-model="employeeInfoForm.employee_number">
                            <label :for="`employee-${employee}-${index}`">
                                <span :class="{'ttl': !input_company_details}">{{ employee }}</span>
                            </label>
                        </div>
                    </div>

                    <div class="form-group field-validation-error">
                        {{ errors[0] }}
                    </div>
                </ValidationProvider>
            </ValidationObserver>
        </div>
        <!--6-->
        <button class="block-toggle-ttl opener collapsed" type="button" data-toggle="collapse" data-target="#heading-6" aria-expanded="false" aria-controls="category">
            <strong>Annual Revenue</strong>
            <div class="plus-minus"></div>
        </button>
        <div class="block-toggle-content collapse" id="heading-6" aria-labelledby="block-toggle-ttl" >
            <div class="choose-block-wrap  revenue-wrap mb-5">
                <div class="item" tabindex="0" v-for="(revenue, index) in revenueAmountList" :style="page_type === 'account-details' ? 'width: 47%' : ''">
                    <input type="radio" name="revenue" class="rad" :id="`revenue-${revenue}-${index}`" :value="revenue" v-model="revenueInfoForm.revenue">
                    <label :for="`revenue-${revenue}-${index}`">
                        <span class="ttl" :style="page_type === 'account-details' ? 'margin-top: 0px' : ''">{{ revenue }}</span>
                    </label>
                </div>
            </div>
        </div>
        <!--7-->
        <button class="block-toggle-ttl opener collapsed" type="button" data-toggle="collapse" data-target="#heading-7" aria-expanded="false" aria-controls="category">
            <strong class="title-required">Company Address</strong>
            <div class="plus-minus"></div>
        </button>
        <div class="block-toggle-content collapse" id="heading-7" aria-labelledby="block-toggle-ttl" >
            <ValidationObserver ref="companyInfoForm">
                <div class="row mb-0">
                    <ValidationProvider class="col-sm-12 col-md-12" name="Company Street" rules="required|max:50" v-slot="{ errors }">
                        <div class="form-group googleAutoComplete mb-0">
                            <label class="lbl lbl-required">Street Address <span>(Corporate)</span></label>
                            <input
                                type="search"
                                id="company_address"
                                class="form-control mb-1"
                                aria-label="Street Address"
                                autocomplete="off"
                                v-model="companyInfoForm.street"
                            >
                        </div>

                        <div class="form-group field-validation-error">
                            {{ errors[0] }}
                        </div>
                    </ValidationProvider>
                    <ValidationProvider class="col-sm-12 col-md-6" name="Company Country" rules="required" v-slot="{ errors }">
                        <div class="form-group mb-0">
                            <label class="lbl lbl-required">Country</label>
                            <select class="custom-select" aria-label="country" v-model="companyInfoForm.country_id">
                                <option :value="null" disabled>Select One</option>
                                <option v-for="country in sorted_countries" :key="country.id" :value="country.id">{{ country.name }}</option>
                            </select>
                        </div>

                        <div class="form-group field-validation-error">
                            {{ errors[0] }}
                        </div>
                    </ValidationProvider>
                    <ValidationProvider class="col-sm-12 col-md-6" name="Company City" rules="required|min:3|max:50" v-slot="{ errors }">
                        <div class="form-group mb-0">
                            <label class="lbl lbl-required">City <span>(Corporate)</span></label>
                            <input
                                type="search"
                                class="form-control mb-1"
                                aria-label="city"
                                autocomplete="off"
                                v-model="companyInfoForm.city"
                            >
                        </div>

                        <div class="form-group field-validation-error">
                            {{ errors[0] }}
                        </div>
                    </ValidationProvider>
                    <ValidationProvider class="col-md-6 col-md-6" name="Company State" rules="required" v-slot="{ errors }">
                        <div class="form-group mb-0">
                            <label class="lbl lbl-required">State</label>
                            <select class="custom-select mb-1" aria-label="state" v-model="companyInfoForm.state_id">
                                <option :value="null" disabled>Select One</option>
                                <option v-for="state in input_states" :value="state.id" :key="state.id">{{ state.name }}</option>
                            </select>
                        </div>

                        <div class="form-group field-validation-error">
                            {{ errors[0] }}
                        </div>
                    </ValidationProvider>
                    <ValidationProvider class="col-sm-12 col-md-6" name="Company Zip" rules="required|zip" v-slot="{ errors }">
                        <div class="form-group mb-0">
                            <label class="lbl lbl-required">Zip Code <span>(Corporate)</span></label>
                            <input type="text" class="form-control mb-1" aria-label="zip" v-mask="['#####', '#####-####']" v-model="companyInfoForm.zip_code">
                        </div>

                        <div class="form-group field-validation-error">
                            {{ errors[0] }}
                        </div>
                    </ValidationProvider>
                    <ValidationProvider class="col-sm-12 col-md-6" name="Company Website" rules="required" v-slot="{ errors }">
                        <div class="form-group mb-0">
                            <label class="lbl lbl-required">Company Website</label>
                            <input type="text" name="website" class="form-control mb-1" aria-label="website" v-model="companyInfoForm.website">
                        </div>

                        <div class="form-group field-validation-error">
                            {{ errors[0] }}
                        </div>
                    </ValidationProvider>
                </div>
                <!--logo-->
                    <div class="form-group row">
                        <label class="col-lg-12 mb-4 lbl lbl-big lbl-required">Company Logo</label>
                        <ValidationProvider class="col-sm-12 col-md-6 company-logo-block d-block" ref="companyLogo" name="Company Logo" :rules="{required_if: !companyInfoForm.no_logo}" v-slot="{ errors }">
                           <div class="d-flex">
                               <div class="logo">
                                   <img :src="companyInfoForm.logo.content" v-if="companyInfoForm.logo.content && companyInfoForm.logo.name">
                                   <i class="fas fa-camera" v-else></i>
                               </div>
                               <div
                                   :class="['logo-upload_link', {'no-logo': companyInfoForm.no_logo}]"
                                   v-if="!companyInfoForm.logo.content && !companyInfoForm.logo.name"
                               >
                                   <label for="logo" :class="['upload_link', {'no-logo': companyInfoForm.no_logo}]">Upload Logo</label>
                               </div>
                               <div class="logo-upload_link" v-else>
                                   <label for="logo" class="link cursor-pointer">Change</label>
                                   <span class="sep"></span>
                                   <label class="link cursor-pointer" @click="removeLogo">Delete</label>
                               </div>
                               <input
                                   type="file"
                                   id="logo"
                                   accept=".jpg, .jpeg, .png, .gif, .tiff"
                                   ref="fileHolder"
                                   class="d-none"
                                   @change="uploadLogo($event.target)"
                               >
                               <p class="img-size-text">
                                   Use for image: gif, png, jpg, tiff Max size: 2 MB
                               </p>
                               <input type="hidden" v-model="companyInfoForm.logo.content">
                           </div>

                            <div class="form-group field-validation-error mt-3">
                                {{ errors[0] }}
                            </div>
                        </ValidationProvider>
                        <div class="col-sm-12 col-md-6 mb-0">
                            <div class="form-group row align-items-center mb-0">
                                <div class="col-12 mt-sm-3">
                                    <div class="form-check">
                                        <input
                                            class="form-check-input-checkbox cursor-pointer"
                                            id="no-logo"
                                            type="checkbox"
                                            v-model="companyInfoForm.no_logo"
                                            @click="removeLogo"
                                        >
                                        <label class="form-check-label cursor-pointer" for="no-logo">I don’t have one</label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
            </ValidationObserver>
        </div>
        <!--8-->
        <button class="block-toggle-ttl opener collapsed" type="button" data-toggle="collapse" data-target="#heading-8" aria-expanded="false" aria-controls="category">
            <strong class="title-required" style="font-size: 1.155rem">
                Are you able and willing to make the commitment to arrive to each monthly meeting and stay for the entirety of the meeting (and to actively participate in the meetings)?
            </strong>
            <div class="plus-minus"></div>
        </button>
        <div class="block-toggle-content collapse" id="heading-8" aria-labelledby="block-toggle-ttl">
            <ValidationObserver ref="meetingInfoForm">
                <ValidationProvider name="Meeting participation" rules="required" v-slot="{ errors }">
                    <div class="form-group row align-items-center">
                        <div class="col-md-2">
                            <div class="form-check mb-3">
                                <input class="form-check-input form-check-input-radio" id="meeting-yes" name="meeting" type="radio" :value="1" v-model="meetingInfoForm.monthly_meeting">
                                <label for="meeting-yes" class="form-check-label">Yes</label>
                            </div>
                            <div class="form-check">
                                <input class="form-check-input form-check-input-radio" id="meeting-no" name="meeting" type="radio" :value="0" v-model="meetingInfoForm.monthly_meeting">
                                <label for="meeting-no" class="form-check-label">No</label>
                            </div>
                        </div>
                    </div>

                    <div class="form-group field-validation-error">
                        {{ errors[0] }}
                    </div>
                </ValidationProvider>
            </ValidationObserver>
        </div>
        <!--9-->
        <button class="block-toggle-ttl opener collapsed" type="button" data-toggle="collapse" data-target="#heading-10" aria-expanded="false" aria-controls="category">
            <strong class="title-required">Who referred you to the SOBs?</strong>
            <div class="plus-minus"></div>
        </button>
        <div class="block-toggle-content collapse" id="heading-10" aria-labelledby="block-toggle-ttl">
            <ValidationObserver ref="sobInfoForm">
                <div class="form-group row align-items-center mb-0">
                    <label class="col-lg-12 lbl lbl-required">Full Name</label>
                    <div class="col-12">
                        <div class="row justify-content-between dashed-bb">
                            <ValidationProvider class="col-lg-6" name="First Name" rules="required|alpha_spaces|min:2|max:20" v-slot="{ errors }">
                                <div class="form-group mb-0">
                                    <input type="text" name="First Name" placeholder='First Name' class="form-control mb-1" v-model="sobInfoForm.referred_first_name">
                                </div>

                                <div class="form-group field-validation-error">
                                    {{ errors[0] }}
                                </div>
                            </ValidationProvider>
                            <ValidationProvider class="col-lg-6" name="Last Name" rules="required|alpha_spaces|min:2|max:20" v-slot="{ errors }">
                                <div class="form-group mb-0">
                                    <input type="text" name="Last Name" placeholder="Last Name" class="form-control mb-1" v-model="sobInfoForm.referred_last_name">
                                </div>

                                <div class="form-group field-validation-error">
                                    {{ errors[0] }}
                                </div>
                            </ValidationProvider>
                        </div>
                    </div>
                </div>
            </ValidationObserver>
        </div>
        <!--10-->
        <button class="block-toggle-ttl opener collapsed" type="button" data-toggle="collapse" data-target="#heading-11" aria-expanded="false" aria-controls="category">
            <strong class="title-required">I hereby understand, acknowledge and agree to the below terms and conditions</strong>
            <div class="plus-minus"></div>
        </button>
        <div class="block-toggle-content collapse" id="heading-11" aria-labelledby="block-toggle-ttl" >
            <ValidationObserver ref="termsConditionsInfoForm">
                <div class="row align-items-center mb-0">
                    <div class="col-6 col-sm-6 col-md-6">
                        <div class="form-group mb-0">
                            <ValidationProvider name="Terms and Conditions" rules="required" v-slot="{ errors }">
                                <div class="form-check">
                                    <input class="form-check-input-checkbox" id="terms" type="checkbox" :true-value="true" :false-value="null" v-model="termsConditionsInfoForm.terms">
                                    <label class="form-check-label" for="terms">
                                        I agree with <a href="javascript:void(0)" class="terms" data-toggle="modal" data-target="#registerTermsConditionsModal">Terms and Conditions</a>
                                    </label>
                                </div>

                                <div class="form-group field-validation-error">
                                    {{ errors[0] }}
                                </div>
                            </ValidationProvider>
                        </div>
                    </div>
                </div>
            </ValidationObserver>
        </div>
        <!--Submit-->
        <div class="buttons-bottom">
            <a href="javascript:void(0)" class="btn btn-yellow" onclick="window.history.back()">Cancel</a>
            <a href="javascript:void(0)" class="btn" @click="validate">Submit</a>
        </div>
    </div>
</template>

<script>
    import { googleAutocomplete } from '../../mixins/google-autocomplete';

    export default {
        name: "DetailsForm",
        props: {
            page_type: {
                type: String,
                required: true
            },
            input_countries: {
                type: Array,
                required: true
            },
            input_states: {
                type: Array,
                required: true
            },
            input_user_details: {
                type: Object,
                required: false
            },
            input_company_details: {
                type: Object,
                required: false
            },
        },
        mixins: [ googleAutocomplete ],
        data() {
            return {
                businessInformationForm: {
                    first_name: null,
                    last_name: null,
                    title: null,
                    email: null,
                    cellphone: null,
                    company_name: null,
                    company_established_year: null,
                    generation: null,
                },
                bioInformationForm: {
                    bio: null
                },
                familyMembersForm: {
                    family_members: [],
                    comment: null,
                    years_in_business: null
                },
                familyBusinessForm: {
                    plan_be_family_members: null,
                    education_level: null
                },
                employeeInfoForm: {
                    employee_number: null
                },
                revenueInfoForm: {
                    revenue: ''
                },
                companyInfoForm: {
                    street: null,
                    country_id: null,
                    city: null,
                    state_id: null,
                    zip_code: null,
                    website: null,
                    logo: {
                        name: '',
                        content: ''
                    },
                    file: null,
                    no_logo: false
                },
                meetingInfoForm: {
                    monthly_meeting: null
                },
                sobInfoForm: {
                    referred_first_name: null,
                    referred_last_name: null,
                },
                termsConditionsInfoForm: {
                    terms: null
                }
            }
        },
        mounted() {
            if (this.input_company_details) {
                this.setBusinessInformationForm();
                this.setBioInformationForm();
                this.setFamilyMembersInformationForm();
                this.setFamilyBusinessInformationForm();
                this.setEmployeeInformationForm();
                this.setRevenueInformationForm();
                this.setCompanyInformationForm();
                this.setMeetingInformationForm();
                this.setSobInformationForm();
                this.setTermsInformationForm();
            }
        },
        computed: {
            sorted_countries() {
                const usa = this.input_countries.find(country => country.name === "United States");
                const other_countries = this.input_countries.filter(country => country.name !== "United States");

                other_countries.sort((a, b) => a.name.localeCompare(b.name));

                return [usa, ...other_countries];
            },
            yearsList() {
                const now = new Date().getUTCFullYear();
                return Array(now - (now - 86)).fill('').map((v, idx) => now - idx);
            },
            familyMembersList() {
                return ['father', 'mother', 'grandfather', 'grandmother', 'sibling', 'aunt', 'uncle', 'cousin', 'other']
            },
            educationLevelList() {
                return [
                    {
                        name: 'Less than High School Diploma',
                        value: 'less_high_school',
                    },
                    {
                        name: 'High School Diploma',
                        value: 'high_school',
                    },
                    {
                        name: 'Doctorate',
                        value: 'doctorate',
                    },
                    {
                        name: 'Bachelors Degree',
                        value: 'bachelors_degree',
                    },
                    {
                        name: 'Masters Degree',
                        value: 'masters_degree',
                    },
                    {
                        name: 'Associates Degree',
                        value: 'associates_degree',
                    },
                ]
            },
            employeesAmountList() {
                return ['1-10', '11-25', '26-49', '50-99', '100-499', '500+']
            },
            revenueAmountList() {
                return ['under $1,000,000', '$1,000,000-$5,000,000', '$5,000,000-$10,000,000', '$10,000,000+']
            }
        },
        methods: {
            setBusinessInformationForm() {
                this.businessInformationForm = {
                    first_name: this.input_company_details.first_name,
                    last_name: this.input_company_details.last_name,
                    title: this.input_company_details.title,
                    email: this.input_company_details.email,
                    cellphone: this.input_company_details.cellphone,
                    company_name: this.input_company_details.company_name,
                    company_established_year: this.input_company_details.company_established_year,
                    generation: this.input_company_details.generation,
                }
            },
            setBioInformationForm() {
                this.bioInformationForm = {
                    bio: this.input_company_details.bio,
                }
            },
            setFamilyMembersInformationForm() {
                this.familyMembersForm = {
                    family_members: this.input_company_details.family_members,
                    comment: this.input_company_details.comment,
                    years_in_business: this.input_company_details.years_in_business
                }
            },
            setFamilyBusinessInformationForm() {
                this.familyBusinessForm = {
                    plan_be_family_members: this.input_company_details.plan_be_family_members,
                    education_level: this.input_company_details.education_level,
                }
            },
            setEmployeeInformationForm() {
                this.employeeInfoForm = {
                    employee_number: this.input_company_details.employee_number,
                }
            },
            setRevenueInformationForm() {
                this.revenueInfoForm = {
                    revenue: this.input_company_details.revenue,
                }
            },
            setCompanyInformationForm() {
                this.companyInfoForm = {
                    street: this.input_company_details.street,
                    country_id: this.input_company_details.country_id,
                    city: this.input_company_details.city,
                    state_id: this.input_company_details.state_id,
                    zip_code: this.input_company_details.zip_code,
                    website: this.input_company_details.website,
                    no_logo: this.input_company_details.no_logo,
                    logo: this.input_company_details && !this.input_company_details.no_logo ?
                        { name: this.input_company_details.logo, content: this.input_company_details.logo} :
                        { name: '', content: '' }
                }
            },
            setMeetingInformationForm() {
                this.meetingInfoForm = {
                    monthly_meeting: this.input_company_details.monthly_meeting,
                }
            },
            setSobInformationForm() {
                this.sobInfoForm = {
                    referred_first_name: this.input_company_details.referred_first_name,
                    referred_last_name: this.input_company_details.referred_last_name,
                }
            },
            setTermsInformationForm() {
                this.termsConditionsInfoForm = {
                    terms: this.input_company_details.terms,
                }
            },
            uploadLogo(e) {
                if (e.files && e.files[0]) {
                    let rateValidated = false;

                    let img = new Image();
                    img.src = window.URL.createObjectURL(e.files[0]);

                    img.onload = () => {
                        if (e.files[0].size < 2e+6) {
                            rateValidated = true;
                        } else {
                            this.$showErrorMessage('File is too large! Acceptable file size: 2MB', 'Oops...')
                            rateValidated = false;
                        }

                        if (rateValidated) {
                            const name = e.files[0];
                            const reader = new FileReader();

                            reader.onloadend = (file) => {
                                this.companyInfoForm.logo = {
                                    name: name.name,
                                    content: reader.result
                                };
                                this.$refs.companyLogo.errors = [];
                            }

                            reader.readAsDataURL(name);
                        }
                    }
                    img.onerror = () => {
                        this.$showErrorMessage('Not a valid file type! Acceptable file types: gif, png, jpg, tiff', 'Oops...')
                    };
                }
            },
            removeLogo() {
                this.companyInfoForm.logo = {
                    name: '',
                    content: ''
                };

                this.$refs.companyLogo.errors = [];
                this.$refs.fileHolder.value = null;
            },
            validate() {
                (async () => {
                    const list = [
                        {
                            name: 'Business Information',
                            value: await this.$refs.businessInformationForm.validate()
                        },
                        {
                            name: 'Bio Information',
                            value: await this.$refs.bioInformationForm.validate()
                        },
                        {
                            name: 'Family Members Information',
                            value: await this.$refs.familyMembersForm.validate()
                        },
                        {
                            name: 'Family Business Information',
                            value: await this.$refs.familyBusinessForm.validate()
                        },
                        {
                            name: 'Employee Information',
                            value: await this.$refs.employeeInfoForm.validate()
                        },
                        {
                            name: 'Company Information',
                            value: await this.$refs.companyInfoForm.validate()
                        },
                        {
                            name: 'Meeting Information',
                            value: await this.$refs.meetingInfoForm.validate()
                        },
                        {
                            name: 'SOB Information',
                            value: await this.$refs.sobInfoForm.validate()
                        },
                        {
                            name: 'Terms and Conditions Information',
                            value: await this.$refs.termsConditionsInfoForm.validate()
                        },
                    ];
                    const form = Object.assign({},
                        this.businessInformationForm,
                        this.bioInformationForm,
                        this.familyMembersForm,
                        this.familyBusinessForm,
                        this.employeeInfoForm,
                        this.revenueInfoForm,
                        this.companyInfoForm,
                        this.meetingInfoForm,
                        this.sobInfoForm,
                        this.termsConditionsInfoForm
                    );
                    const valid = list.every(form => form.value === true);
                    const errors = [];

                    list.forEach(form => {
                        if (!form.value) errors.push(form.name)
                    })

                    if (valid) {
                        this.$showLoadingMessage();

                        setTimeout(() => {
                            if (this.page_type === 'register') {
                                this.sendRequest('/register', form);
                            } else {
                                this.sendRequest('/account/company-details', form);
                            }
                        }, 1000);
                    } else {
                        this.$showValidationErrorMessage(errors, 'The form contains some errors!');
                    }
                })();
            },
            sendRequest(route, form) {
                axios.post(route, form)
                    .then(response => {
                        if (response) {
                            this.$swal.close();

                            if (this.page_type === 'register') {
                                setTimeout(() => {
                                    $('#registerConfirmModal').modal('show');
                                }, 1000);
                            } else {
                                setTimeout(() => {
                                    this.$showSuccessMessage('The form has been successfully updated');
                                }, 500);
                            }
                        }
                    })
                    .catch(error => {
                        setTimeout(() => {
                            const errors = error.response.data.errors[Object.keys(error.response.data.errors)[0]][0]
                            this.$showErrorMessage(errors, 'The form contains some errors!')
                        }, 500);
                    })
            }
        }
    }
</script>

<style scoped lang="less">
    .lbl.lbl-required:after {
        content: '*';
        color: #d54141;
        font-family: Open Sans, sans-serif;
        font-size: 14px;
        font-weight: 400;
        padding-left: 5px;
    }

    .lbl-big-required:after {
        content: '*';
        color: #d54141;
        font-family: Open Sans, sans-serif;
        font-size: 18px;
        font-weight: 400;
        padding-left: 5px;
    }

    .title-required:after {
        content: '*';
        color: #d54141;
        font-family: Open Sans, sans-serif;
        font-size: 18.375px;
        font-weight: 700;
        line-height: 22px;
        padding-left: 5px;
    }

    .field-validation-error {
        color: #d54141;
        font-family: Open Sans, sans-serif;
        font-size: 13px;
        font-weight: 400;
        margin-bottom: 0;
    }

    .no-logo {
        text-decoration: none !important;
        color: grey !important;
        cursor: text !important;
        pointer-events: none !important;
    }

    input[type="search"]::-webkit-search-decoration,
    input[type="search"]::-webkit-search-cancel-button,
    input[type="search"]::-webkit-search-results-button,
    input[type="search"]::-webkit-search-results-decoration {
        -webkit-appearance:none;
    }

    .cursor-pointer{
        cursor: pointer;
    }
</style>

